import { createSingleEntityStore, getSingleEntityActions } from '@recruitee/ngrx';
import type { CandidatesCounters } from '@recruitee/stats-types';
import { CandidatesCountersScope } from '@recruitee/stats-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<CandidatesCounters>()(
  'DashboardCandidatesCounters',
  {
    customActions: adapter => {
      const reducerFunctions = getSingleEntityActions(adapter);
      return {
        fetch: (state, payload: { scope: CandidatesCountersScope }) =>
          reducerFunctions.fetch(state),
      };
    },
  },
);

export {
  actions as DashboardCandidatesCountersActions,
  selectors as DashboardCandidatesCountersSelectors,
  reducer as DashboardCandidatesCountersReducer,
  namespace as DashboardCandidatesCountersNamespace,
};
